import React from 'react';
import {observer} from "mobx-react";

import 'core/components/fields/localizeField.less';


@observer
export default class LocalizeField extends React.Component<any, undefined> {


  render() {

    // let {
    //   children,
    //   style,
    //   ...other,
    //   } = this.props;


    return (
      <span className="lozalize-field fa fa-globe"/>
    )
  }


}



// WEBPACK FOOTER //
// ./src/core/components/fields/localizeField.tsx